export default __webpack_public_path__ + "8984cf03596016ceb67fcd37007566d2.svg";